export enum IncomingThirdPartyType {
    ectosense = 'ectosense',
    embloom = 'embloom',
    emergencyFundus = 'emergencyFundus',
    evidencio = 'evidencio',
    holter = 'holter',
    interapy = 'interapy',
    nsi = 'nsi',
    patientApp = 'patientApp',
    referral = 'referral',
    sso = 'sso',
    teledia = 'teledia',
}
